import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import ForgotPasswordBanner from '../../../assets/images/login/forgot-password.png';
import { currentBranding } from '../../../config/branding';
import { useAppDispatch } from '../../../redux/hooks';
import { setNotificationDetails } from '../../../redux/slice/NotificationSlice';
import MyButton from '../../../shared-components/button/Button';
import CustomInput from '../../../shared-components/custom-input/CustomInput';
import CustomPhoneNumber from '../../../shared-components/custom-phone-number-input/CustomPhoneNumberInput';
import RadioButton from '../../../shared-components/radio-button/RadioButton';
import { setLocalStorageItem } from '../../../shared-functions/LocalStorage';
import { emailValidation, phoneNumberValidation } from '../../../shared-functions/Validation';
import auth from '../../../utils/api/auth';

import OtpVerifyBanner from './OtpVerifyBanner';

/**
 * Login Component
 */
function ForgotPassword() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [credentials, setCredentials] = useState<{
    accountCustomId: string;
    emailOrPhoneNumber: string;
    countryCode: string;
    type: string | number;
  }>({
    accountCustomId: '',
    emailOrPhoneNumber: '',
    type: 'email',
    countryCode: currentBranding === 'energic' ? '966' : '1',
  });

  const [formStatus, setFormStatus] = useState({
    showFormErrors: false,
    errorMessage: '',
    showToastMessage: false,
    buttonLoader: false,
  });

  /**
   * Get input change value and store in credentials state
   * @param name
   * @param changeValue
   */
  const handleCredentialChange = (name: string, changeValue: string | number) => {
    if (name === 'type') {
      setCredentials({
        ...credentials,
        [name]: changeValue,
        emailOrPhoneNumber: '',
      });
    } else {
      setCredentials({
        ...credentials,
        [name]: changeValue,
      });
    }
  };

  /**
   * Function to submit entered cre
   */
  const handleSubmit = () => {
    setFormStatus({
      showFormErrors: true,
      errorMessage: '',
      showToastMessage: false,
      buttonLoader: false,
    });
    if (
      credentials.type !== '' &&
      credentials.countryCode !== '' &&
      (phoneNumberValidation(credentials.emailOrPhoneNumber) ||
        emailValidation(credentials.emailOrPhoneNumber))
    ) {
      setFormStatus({
        showFormErrors: false,
        errorMessage: '',
        showToastMessage: false,
        buttonLoader: true,
      });
      const request: any = {
        countryCode: credentials.countryCode,
        emailOrPhoneNumber: credentials.emailOrPhoneNumber,
      };

      if (credentials?.accountCustomId) {
        request.accountCustomId = credentials.accountCustomId;
      }

      auth
        .forgotPassword(request)
        .then(() => {
          setFormStatus({
            showFormErrors: false,
            errorMessage: '',
            showToastMessage: false,
            buttonLoader: false,
          });
          setLocalStorageItem('passwordReset', credentials);
          navigate('../login/forgot-password-otp-verification');
        })
        .catch((error) => {
          setFormStatus({
            showFormErrors: true,
            errorMessage: error?.response?.data?.message || '',
            showToastMessage: true,
            buttonLoader: false,
          });
          // Redirect to OTP enter page even if the OTP not send
          // setLocalStorageItem('passwordReset', credentials);
          // navigate('../login/forgot-password-otp-verification');

          // Display a user-friendly message
          dispatch(
            setNotificationDetails({
              type: 'error',
              notificationDetails: {
                statusCode: error?.response?.data?.code || 200,
                message: error?.response?.data?.message || 'Something went wrong!',
              },
            }),
          );
        });
    }
  };

  return (
    <div className="forgot-password-wrap">
      <div className="forgot-password-banner">
        <OtpVerifyBanner
          imageSrc={ForgotPasswordBanner}
          bannerTittle="Enter the OTP"
          bannerDescription="Please enter the OTP. Received that which you registered email id"
        />
      </div>
      <div className="forgot-password-wrap">
        <div className="forgot-password-container">
          <h1>Forgot Password</h1>
          <RadioButton
            name="type"
            value={credentials.type}
            list={[
              {
                label: 'Email',
                value: 'email',
              },
              {
                label: 'Phone Number',
                value: 'phone',
              },
            ]}
            onChangeValue={handleCredentialChange}
          />
          {credentials.type === 'email' ? (
            <CustomInput
              inputLabel="Email"
              type="text"
              placeholder="Enter the email"
              name="emailOrPhoneNumber"
              valueRequired
              value={credentials.emailOrPhoneNumber}
              onChangeValue={handleCredentialChange}
              error={!emailValidation(credentials.emailOrPhoneNumber) && formStatus.showFormErrors}
              errorMessage="Invalid email id"
            />
          ) : (
            <CustomPhoneNumber
              inputLabel="Phone Number"
              placeholder="Enter the Phone number"
              name="emailOrPhoneNumber"
              value={credentials.emailOrPhoneNumber}
              onChangeValue={handleCredentialChange}
              valueRequired
              error={
                !phoneNumberValidation(credentials.emailOrPhoneNumber) && formStatus.showFormErrors
              }
              errorMessage="Invalid phone number"
              countryCode={credentials.countryCode}
            />
          )}
          <CustomInput
            inputLabel="Account ID (Leave blank for primary account)"
            type="text"
            placeholder="Enter the account Id"
            name="accountCustomId"
            value={credentials.accountCustomId}
            onChangeValue={handleCredentialChange}
          />
          <MyButton
            label="Submit"
            buttonType="submit"
            onClickFunc={handleSubmit}
            loading={formStatus.buttonLoader}
            disableButton={formStatus.buttonLoader}
          />
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
